import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * Descope appends handshake params (`code`, `descope-login-flow`) to the URL
 * during the login redirect. Nothing in the app reads them — only the Descope
 * SDK consumes them, internally — so once the redirect is done they are dead
 * weight that the client-sync effects would otherwise carry forward and pin
 * into the URL. Strip them regardless of user type; the effect no-ops once
 * they're gone.
 */
const TRANSIENT_AUTH_PARAMS = ['code', 'descope-login-flow'] as const;

export const useStripTransientAuthParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const hasTransientParam = TRANSIENT_AUTH_PARAMS.some((key) =>
    searchParams.has(key)
  );

  useEffect(() => {
    if (!hasTransientParam) return;

    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        for (const key of TRANSIENT_AUTH_PARAMS) next.delete(key);
        return next;
      },
      { replace: true }
    );
  }, [hasTransientParam, setSearchParams]);
};
